/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { PlacesSite } from '../models/places-site';
import { Envelope } from '../models/envelope';
@Injectable({
  providedIn: 'root',
})
class SiteService extends __BaseService {
  static readonly SiteGetAllPath = '/api/site';
  static readonly SiteUpdatePath = '/api/site';
  static readonly SiteCreatePath = '/api/site';
  static readonly SiteGetPath = '/api/site/{id}';
  static readonly SiteDeletePath = '/api/site/{id}';
  static readonly SiteGetSiteStatusPath = '/api/site/online/{projectId}';
  static readonly SiteGetByExternalIdPath = '/api/site/external/{externalId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return OK
   */
  SiteGetAllResponse(): __Observable<__StrictHttpResponse<Envelope<PlacesSite[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/site`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<PlacesSite[]>>;
      })
    );
  }
  /**
   * @return OK
   */
  SiteGetAll(): __Observable<Envelope<PlacesSite[]>> {
    return this.SiteGetAllResponse().pipe(
      __map(_r => _r.body as Envelope<PlacesSite[]>)
    );
  }

  /**
   * @param entity undefined
   * @return OK
   */
  SiteUpdateResponse(entity: PlacesSite): __Observable<__StrictHttpResponse<Envelope<PlacesSite>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = entity;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/site`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<PlacesSite>>;
      })
    );
  }
  /**
   * @param entity undefined
   * @return OK
   */
  SiteUpdate(entity: PlacesSite): __Observable<Envelope<PlacesSite>> {
    return this.SiteUpdateResponse(entity).pipe(
      __map(_r => _r.body as Envelope<PlacesSite>)
    );
  }

  /**
   * @param entity undefined
   * @return OK
   */
  SiteCreateResponse(entity: PlacesSite): __Observable<__StrictHttpResponse<Envelope<PlacesSite>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = entity;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/site`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<PlacesSite>>;
      })
    );
  }
  /**
   * @param entity undefined
   * @return OK
   */
  SiteCreate(entity: PlacesSite): __Observable<Envelope<PlacesSite>> {
    return this.SiteCreateResponse(entity).pipe(
      __map(_r => _r.body as Envelope<PlacesSite>)
    );
  }

  /**
   * @param id undefined
   * @return OK
   */
  SiteGetResponse(id: number): __Observable<__StrictHttpResponse<Envelope<PlacesSite>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/site/${encodeURIComponent(id)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<PlacesSite>>;
      })
    );
  }
  /**
   * @param id undefined
   * @return OK
   */
  SiteGet(id: number): __Observable<Envelope<PlacesSite>> {
    return this.SiteGetResponse(id).pipe(
      __map(_r => _r.body as Envelope<PlacesSite>)
    );
  }

  /**
   * @param id undefined
   * @return OK
   */
  SiteDeleteResponse(id: number): __Observable<__StrictHttpResponse<Envelope<any>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/site/${encodeURIComponent(id)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<any>>;
      })
    );
  }
  /**
   * @param id undefined
   * @return OK
   */
  SiteDelete(id: number): __Observable<Envelope<any>> {
    return this.SiteDeleteResponse(id).pipe(
      __map(_r => _r.body as Envelope<any>)
    );
  }

  /**
   * @param projectId undefined
   * @return OK
   */
  SiteGetSiteStatusResponse(projectId: string): __Observable<__StrictHttpResponse<Envelope<any>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/site/online/${encodeURIComponent(projectId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<any>>;
      })
    );
  }
  /**
   * @param projectId undefined
   * @return OK
   */
  SiteGetSiteStatus(projectId: string): __Observable<Envelope<any>> {
    return this.SiteGetSiteStatusResponse(projectId).pipe(
      __map(_r => _r.body as Envelope<any>)
    );
  }

  /**
   * @param externalId undefined
   * @return OK
   */
  SiteGetByExternalIdResponse(externalId: string): __Observable<__StrictHttpResponse<Envelope<any>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/site/external/${encodeURIComponent(externalId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<any>>;
      })
    );
  }
  /**
   * @param externalId undefined
   * @return OK
   */
  SiteGetByExternalId(externalId: string): __Observable<Envelope<any>> {
    return this.SiteGetByExternalIdResponse(externalId).pipe(
      __map(_r => _r.body as Envelope<any>)
    );
  }
}

module SiteService {
}

export { SiteService }
